import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toiletTrainingAge2: BlogMetaData = {
  title: '2歳のトイレトレーニング｜始め方とイヤイヤ期でも進めやすいコツ',
  description:
    '2歳のトイレトレーニングはいつから？始め方の判断、イヤイヤ期でも進めやすいやり方、無理なく続けるコツをモンテッソーリの視点で解説。焦らず本人のペースで進めるための具体策をまとめました。',
  thumbnailUrl: '/img/blog-toilet-training-age-2.webp',
  filePath: buildBlogFilePath('toilet-training-age-2'),
  category: BLOG_CATEGORY.PARENTING,
};
